export const organizationsApiHandler = {
  getOrganization: {
    method: "GET",
    path: () => `organizations-dashboard`
  },
  getIdFromPrefix: {
    method: "GET",
    path: (payload: { prefix: string | number }) => `organizations-dashboard/prefix/${payload.prefix}`
  },
  getIdFromUrl: {
    method: "GET",
    path: () => `organizations-dashboard/url`
  },
  getOrganizationsRegistrationFormFields: {
    method: "GET",
    path: () => `organizations-dashboard/registration`
  },
  getOrganizationsRegistrationFormFieldsSort: {
    method: "GET",
    path: () => `organizations-dashboard/registration`
  },
  getOrganizationsTerminology: {
    method: "GET",
    path: () => `organizations-dashboard/terminology`
  },
  getOrganizationsTerminologyDashboard: {
    method: "GET",
    path: () => `organizations-dashboard/terminology/dashboard`
  },
  getRegistrationFormFieldsSort: {
    method: "GET",
    path: () => `organizations-dashboard/registration/sort`
  },
  getOrganizationAssessments: {
    method: "GET",
    path: () => `org-assessments-management/all-assessments`
  },
  getLearningCategories: {
    method: "GET",
    path: () => `learning-categories`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number}
  },
  getParentLearningCategoriesWithCourses: {
    method: "GET",
    path: () => `learning-categories/parent`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number}
  },
  getParentLearningCategories: {
    method: "GET",
    path: () => `learning-categories/organization-parent-categories`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number}
  },
  getSingleParentLearningCategory: {
    method: "GET",
    path: (payload: { parentId: string | number }) => `learning-categories/parent/${payload.parentId}`,
    params: {} as {'search'?: string | number}
  }
};